export default __webpack_public_path__ + "static/media/image-speakers.c428eea3.png";